export default function TermsAndConditions() {
  return <h1>Terms and Conditions</h1>;
}
